import { createSlice } from "@reduxjs/toolkit";
import { LanguagesEnum } from "common/enums/languages";
import { ThemeEnum } from "../../common/enums/theme";

interface IPreferencesState {
  theme: ThemeEnum;
  language: LanguagesEnum;
}

const initialState: IPreferencesState = {
  theme: ThemeEnum.LIGHT,
  language: LanguagesEnum.ENGLISH,
};

export const preferencesSlice = createSlice({
  name: "preferences",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    resetPreferences: (state) => {
      state = initialState;
    },
  },
});

export const { setTheme, resetPreferences, setLanguage } =
  preferencesSlice.actions;

export default preferencesSlice.reducer;
